<template>
    <div>
        <template v-if="window_width >= 992">

            <!-- Edit Profile -->
            <b-dropdown-item @click="edit(user.id)" :class="!user_permissions.includes('read-users') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-users') ? $t('permission.permission_denied', { permission: 'read-users' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('read-users')">{{ $t('simple.edit') }}</b-dropdown-item>

            <!-- Password -->
            <b-dropdown-item  @click="password()" :class="!user_permissions.includes('update-users') ? 'cursor-not-allowed' : ''"
                              v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-users') ? $t('permission.permission_denied', { permission: 'update-users' }) : '', customClass: 'tooltip-dark' }"
                              :disabled="!user_permissions.includes('update-users')">{{  $t('user.password') }}</b-dropdown-item>

            <!-- Logout -->
            <b-dropdown-item @click="logout()">{{  $t('auth.logout') }}</b-dropdown-item>

        </template>

        <template v-else>

            <!-- Edit Profile -->
            <b-link class="plus-header-accordion-links" @click="edit(user.id)" :class="!user_permissions.includes('read-users') ? 'cursor-not-allowed' : ''"
                    v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-users') ? $t('permission.permission_denied', { permission: 'read-users' }) : '', customClass: 'tooltip-dark' }"
                    :disabled="!user_permissions.includes('read-users')">{{ $t('simple.edit') }}</b-link>
            <!-- Password -->
            <b-link class="plus-header-accordion-links"  @click="password()" :class="!user_permissions.includes('update-users') ? 'cursor-not-allowed' : ''"
                    v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-users') ? $t('permission.permission_denied', { permission: 'update-users' }) : '', customClass: 'tooltip-dark' }"
                    :disabled="!user_permissions.includes('update-users')">{{  $t('user.password') }}</b-link>
            <!-- Logout -->
            <b-link class="plus-header-accordion-links" @click="logout()">{{  $t('auth.logout') }}</b-link>


        </template>
    </div>

</template>
<script>

import {mapActions, mapGetters} from 'vuex';

import { create } from 'vue-modal-dialogs'
import UserEdit from "../Settings/Modal/UserEdit";
import UserPassword from '../Settings/Modal/UserPassword.vue'


export default {

    props: ['user'],

    mounted() {
        this.$nextTick(() => {
              window.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
            window.removeEventListener('resize', this.onResize); 
    },

    data: function () {
        return {
            window_width: window.innerWidth,
        }
    },

    methods: {
        onResize() {
            this.window_width = window.innerWidth;
        },  

        logout: async function() {
          this.userLogout();
        },
        edit: async function(id) {
          // Show User edit modal
          const user_edit = create(UserEdit, 'id' , 'is_user');
          if (await user_edit(id, true) ){
            //
          }
        },
        password: async function() {
            // Show user logout modal
            const user_password = create(UserPassword);
            if (await user_password() ){
            }
        },


        ...mapActions('User', [
          'userLogout'
        ]),
    },
  computed: {
    ...mapGetters({
      user_permissions: 'User/getUserPermissions',
    }),
    permissionsReady() {
      return Array.isArray(this.user_permissions) && this.user_permissions.length > 0;
    }
  },

        // computed: {
        // // Map getters
        // ...mapGetters({
        //     user: 'User/getUser',
        // }),
        
        // },


}

</script>